import { render, staticRenderFns } from "./PieChartSkeleton.vue?vue&type=template&id=d2b606c6"
import script from "./PieChartSkeleton.vue?vue&type=script&lang=ts"
export * from "./PieChartSkeleton.vue?vue&type=script&lang=ts"
import style0 from "./PieChartSkeleton.vue?vue&type=style&index=0&id=d2b606c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports